import React, { useEffect } from "react";
import { numToCurrency } from "../utils/transformators";

const useTransformCurrency = (USQSData, setUSQS, inEuros, ERrate, currencyChangeFlag) => {
  // console.log(USQSData);
  useEffect(() => {
    const varnames = [
      "materialcost",
      "pcomission",
      "pfinancecost",
      "outdrayage",
      "loading",
      "outcollectcharges",
      "outboundothers",
      "totaloutbound",
      "outboundcost",
      "oceanfreight",
      "freightpmt",
      "materialvalue",
      "dutyfee",
      "harborfee",
      "merchprocfee",
      "flatfee",
      "tsca",
      "isf",
      "totalcentryfee",
      "importcustomsfee",
      "indrayage",
      "unloading",
      "incollectcharges",
      "inboundothers",
      "totalinbound",
      "inboundcost",
      "scomission",
      "sfinancecost",
      "inspectioncost",
      "legal",
      "pallets",
      "other",
      "totalcost",
      "insurancecost",
      "interestcost",
      "totallandedcost",
      "salesprice",
      "profitpmt",
      "profittotal",
      "turnover",
      "netback",
      "storagecost",
    ];

    const docurrencychange = () => {
      setUSQS((prev) => {
        const updatedFields = varnames.reduce((acc, key) => {
          const baseValue = USQSData[key];
          const convertedValue = inEuros ? numToCurrency(baseValue * ERrate, 2, "€") : numToCurrency(baseValue);
          acc[key] = convertedValue;
          return acc;
        }, {});

        return {
          ...prev,
          ...updatedFields,
        };
      });
    };
    docurrencychange();
  }, [inEuros, currencyChangeFlag]);
};

export default useTransformCurrency;
